import { observeElementOffset, observeElementRect, useVirtualizer } from '@tanstack/react-virtual';

import type { BaseRowData } from '@adv-frontend/data-provider';

import { useVirtualBodyContent } from './VirtualBodyContent';
import type { VirtualBodyProps } from './VirtualBody.types';
import { useRowVirtualizationOptions } from './useRowVirtualizationOptions';

const isJSDOM = globalThis?.navigator?.userAgent?.includes('jsdom/') ?? false;
const fakeObserver = () => () => {};

export function ElementVirtualRows<RowData extends BaseRowData>(props: VirtualBodyProps<RowData>) {
    const options = useRowVirtualizationOptions(props);
    // eslint-disable-next-line react-hooks/incompatible-library -- Виртуализатор управляет диапазоном строк.
    const rowVirtualizer = useVirtualizer<HTMLDivElement, HTMLDivElement>({
        ...options,
        getScrollElement: () => props.gridRef.current,
        scrollPaddingEnd: props.gridHeaderRef.current?.offsetHeight,
        // В jsdom наблюдатели не работают, поэтому виртуализированный контент ориентируется на initialRect.
        observeElementRect: isJSDOM ? fakeObserver : observeElementRect,
        observeElementOffset: isJSDOM ? fakeObserver : observeElementOffset,
    });

    return useVirtualBodyContent({ ...props, mode: 'element', rowVirtualizer });
}
